import "./ICP.scss";
import externalUrlIcon from "../../assets/images/icon-external-link.svg";

const ICPInformation = () => (
	<a className="tc-labeltext" href="https://beian.miit.gov.cn/">
		Shanghai, ICP prepared No. 14027180
		<img className="pl-1" src={externalUrlIcon} />
	</a>
);
export default ICPInformation;
